import cn from '../assets/images/flags/China.png'
import en from '../assets/images/flags/United States.png'
import project from './config'

export const langinit = function(userarea, _this) {
    const lang = localStorage.lang
    if (lang) userarea = lang === 'cn' ? 0 : 1

    switch (parseInt(userarea)) {
        case 0:
            _this.$i18n.locale = 'cn'
            _this.src = project.cn
            _this.langFlag = cn
            _this.value = '中文简体'
            break
        case 1:
            _this.$i18n.locale = 'en'
            _this.src = project.en
            _this.langFlag = en
            _this.value = 'English'
            break
    }
}

export const langchange = function(item, _this) {
    // 切换语言
    switch (item) {
        case 'cn':
            _this.$store.state.language = 'cn'
            _this.$i18n.locale = 'cn'
            _this.src = project.cn
            _this.langFlag = cn
            localStorage.setItem('lang', 'cn')
            break
        case 'en':
            _this.$store.state.language = 'en'
            _this.$i18n.locale = 'en'
            _this.src = project.en
            _this.langFlag = en
            localStorage.setItem('lang', 'en')
            break
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js